var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKzFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#151515",
    fillRule: "evenodd",
    d: "M15.297.703c.469.469.703 1 .703 1.594v11.406c0 .646-.221 1.19-.664 1.633-.443.443-.987.664-1.633.664H9.906v-5.703h2.297l.5-2.797H9.906V5.594h2.797V2.797H9.906c-.75 0-1.406.279-1.969.836-.562.557-.843 1.211-.843 1.961V7.5H5.203v2.797H7V16H2.297c-.594 0-1.125-.237-1.594-.711C.234 14.815 0 14.25 0 13.594V2.297C0 1.703.234 1.172.703.703 1.172.234 1.703 0 2.297 0h11.406c.594 0 1.125.234 1.594.703z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKzFacebook);
export default __webpack_public_path__ + "static/media/kz-facebook.5ad3e9ceda994ec2f9224f1b8435fa16.svg";
export { ForwardRef as ReactComponent };